import { main } from "../constants/actionTypes";
import { User } from "../types/user";

export const setUser = (user: User | null) => ({
  type: main.SET_USER,
  payload: { user },
});
